import { render, staticRenderFns } from "./KtTable.vue?vue&type=template&id=4792243c&"
import script from "./KtTable.vue?vue&type=script&lang=js&"
export * from "./KtTable.vue?vue&type=script&lang=js&"
import style0 from "./KtTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports